<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @font-face {
    font-family: 'icomoon';
    src:  url('assets/fonts/icomoon.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  @font-face{
    font-family: 'arial';
    src:  url('assets/fonts/ARIAL.ttf');
    /*  src: url("assets/fonts/ARIAL.ttf");*/
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon','arial' !important;

    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body,html{
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: #111F2C;
    font-family: 'icomoon','arial';
  }
#app {
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 16px;
}
  i,em{
    font-style: normal;
  }
  .home-roll img{
    height: 30px;
    width: auto;
  }
  .message-title_info img,.home-cover-text-div img,.home-pop-text img{
    width: auto;
    height: auto;
    max-width: 100%;
  }
  .home-cover-text-div p,.home-pop-text p{
    margin: 0;
    padding: 0;
    word-wrap:break-word
  }
  .bet-main-cover p{
    margin: 0;
    padding: 0;
  }
  .bet-main-cover img{
    width: 100%;
    height: auto;
  }
  .logo-title p{
    padding: 0;
    margin: 0;

  }
  .logo-title img{
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue